import { render, staticRenderFns } from "./eturahoitus.vue?vue&type=template&id=81c2f0f4&"
import script from "./eturahoitus.vue?vue&type=script&lang=js&"
export * from "./eturahoitus.vue?vue&type=script&lang=js&"
import style0 from "./eturahoitus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports